//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { db } from "../../main.js";

export default {
  data() {
    return {
      isEditing: false,
      showDeleteModal: false,
    };
  },
  methods: {
    deleteClass(key) {
      db.ref("classes/" + key).remove();
      this.showDeleteModal = false;
    },
    updateClass(key, data) {
      db.ref("classes/" + key).set(data);
      this.isEditing = false;
    },
  },
  props: {
    classKey: {
      default: null,
    },
    classObj: {
      default: null,
    },
  },
};
